/* eslint-disable */
import VueRouter from "vue-router";
import Home from "../pages/Home"; // 引入组件
import Contact from "../pages/Contact"; // 引入组件
import OauthLoading from "../pages/OauthLoading"; // 引入组件
import CasiLoading from "../pages/CasiLoading.vue"; // 引入组件
import TopicAssistantResult from "../pages/TopicAssistantResult"; // 引入选题结果页面
import TopicAssistantResultIfram from "../pages/TopicAssistantResultIfram"; // 引入选题结果页面
import FullTxtArtAnalysisResult from "../pages/FullTxtArtAnalysisResult.vue";
import TopicAssistantHome from "../pages/TopicAssistantHome.vue";

// import { frontRootUrl } from "../config/index";

// 创建路由实例并配置 history 模式
const router = new VueRouter({
  // 开启 history 模式（去掉 URL 中的 #）
  mode: "history",
  // 可选：部署的基础路径，比如项目部署在 https://xxx.com/my-vue/ 下，就写 '/my-vue/'
  // base: /test/,
  // 路由规则
  routes: [
    {
      // 访问根路径时，重定向到login组件
      // 移除或修改强制重定向，避免刷新时被拦截
      path: "/",
      redirect: to => {
        return "/literatureSearch";
      },
    },
    {
      name: "ai_home", // 路由名
      path: "/ai_home", // 路由路径
      component: Home, // 对应组件名
      meta: {
        keepAlive: false, // 需要被缓存
      },
      // // 如果有嵌套子路由，需按照下面的方式写，注意子路由path前面没有斜杠
      // // 对应页面的template标签中不要直接放文本，得有子标签，否则可能会导致项目启动时卡住
      // children: [
      //     {
      //         name:'upload_file', 	  	// 路由名
      //         path:'upload_file',	  		// 路由路径
      //         component:UploadFile   		// 对应组件名，子路由前面没有斜杠
      //     },
      // ],
    },
    {
      name: "topic_assistant",
      path: "/topic-assistant",
      component: TopicAssistantHome,
      meta: {
        keepAlive: false,
      },
    },
    {
      name: "oauth_loading", // 路由名
      path: "/oauth_loading", // 路由路径
      component: OauthLoading, // 对应组件名
      meta: {
        keepAlive: false, // 需要被缓存
      },
    },
    {
      name: "contact", // 路由名
      path: "/contact", // 路由路径
      component: Contact, // 对应组件名
      meta: {
        keepAlive: false, // 需要被缓存
      },
    },
    {
      name: "casiLoading", // 路由名
      path: "/casiLoading", // 路由路径
      component: CasiLoading, // 对应组件名
      meta: {
        keepAlive: false, // 需要被缓存
      },
    },
    {
      name: "topic_assistant_result", // 路由名
      path: "/topic_assistant_result", // 路由路径
      component: TopicAssistantResult, // 对应组件名
      meta: {
        keepAlive: false, // 需要被缓存
      },
    },
    {
      name: "topic_assistant_result_ifram", // 路由名
      path: "/topic_assistant_result_ifram", // 路由路径
      component: TopicAssistantResultIfram, // 对应组件名
      meta: {
        keepAlive: false, // 需要被缓存
      },
    },
    {
      // 匹配所有其他路由，防止 qiankun 子应用跳转时，主应用找不到路由而导致组件卸载或报错
      // 不进行重定向，而是渲染一个空的占位组件，或者不渲染任何东西（让 qiankun 去渲染子应用）
      path: "/full_txt_art_analysis_result",
      component: FullTxtArtAnalysisResult,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "*",
      component: { render: h => h("div") },
    },
  ],
});

// // 创建路由器
// const router = new VueRouter({
// 	routes:[
// 		{
// 			// 访问根路径时，重定向到login组件
// 			path: '/',
// 			redirect: 'home'
// 		},
// 		{
// 			name:'home', 	  // 路由名
// 			path:'/home',	  // 路由路径
// 			component:Home   // 对应组件名
// 			// // 如果有嵌套子路由，需按照下面的方式写，注意子路由path前面没有斜杠
// 			// // 对应页面的template标签中不要直接放文本，得有子标签，否则可能会导致项目启动时卡住
// 			// children: [
//             //     {
//             //         name:'upload_file', 	  	// 路由名
//             //         path:'upload_file',	  		// 路由路径
//             //         component:UploadFile   		// 对应组件名，子路由前面没有斜杠
//             //     },
//             // ],
// 		},
// 		{
// 			name:'oauth_loading', 	  // 路由名
// 			path:'/oauth_loading',	  // 路由路径
// 			component:OauthLoading   // 对应组件名
// 			// // 如果有嵌套子路由，需按照下面的方式写，注意子路由path前面没有斜杠
// 			// // 对应页面的template标签中不要直接放文本，得有子标签，否则可能会导致项目启动时卡住
// 			// children: [
//             //     {
//             //         name:'upload_file', 	  	// 路由名
//             //         path:'upload_file',	  		// 路由路径
//             //         component:UploadFile   		// 对应组件名，子路由前面没有斜杠
//             //     },
//             // ],
// 		},
// 	]
// })

export default router;
